/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Email_Verify_HintInputs */



/**
* | output |
* | --- |
* | "Click it to verify your email and set your password." |
*
* @param {Profile_Email_Verify_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_email_verify_hint = /** @type {((inputs?: Profile_Email_Verify_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Email_Verify_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquez dessus pour vérifier votre email et définir votre mot de passe.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haz clic en él para verificar tu email y establecer tu contraseña.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Clique nele para verificar seu email e definir sua senha.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cliccalo per verificare la tua email e impostare la tua password.")
	return /** @type {LocalizedString} */ ("Click it to verify your email and set your password.")
});